import { render, staticRenderFns } from "./PremiumUpsellBanner.vue?vue&type=template&id=42939a6a&scoped=true&"
import script from "./PremiumUpsellBanner.vue?vue&type=script&lang=js&"
export * from "./PremiumUpsellBanner.vue?vue&type=script&lang=js&"
import style0 from "./PremiumUpsellBanner.vue?vue&type=style&index=0&id=42939a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42939a6a",
  null
  
)

export default component.exports